{
  "App": "Приложение",
  "Profile": "Профиль",
  "My Account": "Мой профиль",
  "Contacts": "Контакты",
  "Preferences": "Предпочтения",
  "Family Language": "Язык семьи",
  "Program Consent": "Согласие на участие в программе",
  "Yes": "Да",
  "No": "Нет",
  "Not submitted": "Не предоставлено",
  "See anything missing? Contact your Caring Adult": "Что-то не так? Свяжитесь со специалистом по поддержке",
  "Messages": "Сообщения",
  "Caring Adult for": "Специалист по поддержке",
  "Former Caring Adult for": "Бывший специалист по поддержке",
  "Write your message here...": "Напишите свое сообщение здесь...",
  "I need help with": "Мне нужна помощь с",
  "Academic": "Обучением",
  "After School/ Out of School": "Послешкольными/внешкольными занятиями",
  "Applying for benefits": "Подачей заявления на получение льгот",
  "Childcare": "Уходом за детьми",
  "Employment / Adult Education": "Трудоустройством/образованием для взрослых",
  "Food": "Едой",
  "Housing": "Жильем",
  "Legal services": "Юридические услуги",
  "Material Resources / Clothing / Laundry": "Материальными ресурсами/одеждой/прачечной",
  "Mental/emotional health": "Психическим/эмоциональным здоровьем",
  "Physical health/asthma": "Физическим здоровьем/астмой",
  "Transportation": "Транспортмаршруты транспорта",
  "Send": "Отправить",
  "Today": "Сегодня",
  "No messages yet": "Сообщений пока нет",
  "No messages": "Сообщений нет",
  "Start a conversation below": "Начните разговор ниже",
  "This Caring Adult is no longer available": "Этот специалист по поддержке больше не доступен",
  "No longer available ": "Больше не доступен ",
  "Monday": "Понедельник",
  "Tuesday": "Вторник",
  "Wednesday": "Среда",
  "Thursday": "Четверг",
  "Friday": "Пятница",
  "Saturday": "Суббота",
  "Sunday": "Воскресенье",
  "Emergency Contacts": "Контакты для экстренных ситуаций",
  "Supervisor of Social Workers for the Bronx": "Руководитель социальных работников Бронкса",
  "Student Services Manager, High School District": "Менеджер по работе с учащимися, школьный округ",
  "Social Worker, Central Crisis Support Team": "Социальный работник, центральная группа кризисной поддержки (Central Crisis Support Team)",
  "Support Line": "Горячая линия поддержки",
  "Suicide and Crisis Lifeline": "Горячая линия по предотвращению самоубийств и поддержке в кризисной ситуации (Suicide and Crisis Lifeline)",
  "Emergencies": "Экстренные ситуации",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "Если вы столкнулись с угрожающей жизни экстренной ситуацией и нуждаетесь в помощи прямо сейчас, позвоните или отправьте сообщение на номер 911",
  "About New Visions": "О New Visions",
  "Privacy and Terms": "Конфиденциальность и условия",
  "Homepage": "Домашняя страница",
  "Home Page": "Домашняя страница",
  "My family": "Моя семья",
  "Available Services": "Доступные услуги",
  "Grade": "класс",
  "School": "Школа",
  "Attendance this year": "Посещаемость в этом году",
  "Absences last 5 days": "Пропуски за последние 5 дней",
  "Caring Adult": "Специалист по поддержке",
  "Message": "Сообщение",
  "Not available": "Недоступно",
  "Not yet assigned": "Еще не назначено",
  "No absences": "Нет пропусков",
  "Phone not available": "Телефон недоступен",
  "Email address not available": "Адрес электронной почты недоступен",
  "January": "Январь",
  "February": "Февраль",
  "March": "Март",
  "April": "Апрель",
  "May": "Май",
  "June": "Июнь",
  "July": "Июль",
  "August": "Август",
  "September": "Сентябрь",
  "October": "Октябрь",
  "November": "Ноябрь",
  "December": "Декабрь",
  "Sidenav": "Боковая панель навигации",
  "Home": "Домашняя страница",
  "Log out": "Выйти",
  "Accessibility": "Доступность",
  "Skip to main content": "Перейти к основному содержанию",
  "Email": "Электронная почта",
  "Phone": "Телефон",
  "Family Portal": "Семейный портал",
  "Every Child and Family is Known": "«Каждый ребенок и семья известны»",
  "Family Portal: Every Child and Family is Known": "Семейный портал: «Каждый ребенок и семья известны»",
  "Close menu": "Закрыть меню",
  "Open menu": "Открыть меню",
  "Notes": "Примечания",
  "Send message": "Отправить сообщение",
  "Languages": "Языки",
  "Consent status": "Статус согласия",
  "Select": "Выбрать",
  "Language selector": "Выбор языка",
  "Sorry": "Извини",
  "we couldn't find that page": "мы не смогли найти эту страницу",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "У вас еще нет прав для входа на Семейный портал. Пожалуйста, обратитесь к своему Заботящемуся взрослому для получения доступа."
}